import { useQuery } from '@tanstack/react-query'
import { httpGetMMListingActivity } from '@/features/luxe-submissions/http/luxe-submissions.http'

export const MM_LISTING_ACTIVITY_QUERY_KEY = 'mm-listing-activity'

export const useGetMMListingActivity = (submissionId: string) =>
	useQuery({
		queryKey: [MM_LISTING_ACTIVITY_QUERY_KEY, submissionId],
		queryFn: () => httpGetMMListingActivity(submissionId),
		enabled: !!submissionId
	})
